import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getLiquidacionesListaSellers,
    getTiposConceptos,
    postNovedad
} from '../../../../api/axios';
import { fetchLiquidacionesListaSellers } from '../../../../actions/sellersActions';
import { fetchListaConceptos } from '../../../../actions/tiposActions';
import { DropDownArrow, EstiloCombos } from "../../../../template/CustomStyle";
import GoBackArrow from '../../../General/GoBackArrow';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { validateNumber } from "../../../../utilities/formatoNumeros";
import { filtroSesenta } from "../../../../utilities/fechasFiltro";
const fechaFiltro = filtroSesenta();


class NovedadNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listSellers: [],
            comboSeller: { label: "", value: "" },
            comboConceptos: { label: "", value: "" },
            fecha: fechaFiltro.hasta,
            fechaDesdeSesenta: fechaFiltro.desde,
            comision: 0,
            importe: "",
            observaciones: "",
            ordenReferencia: ""
        }
    };

    componentDidMount() {
        this.props.fetchLiquidacionesListaSellers();
        this.props.fetchListaConceptos();

        /*CARGA DE SELLERS*/
        const cargasellers = getLiquidacionesListaSellers().then(res => {
            let array = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            })
            this.setState({ listSellers: array });
        });

        /*CARGA DE CONCEPTOS*/
        getTiposConceptos().then(res => {
            let listaAccion = res.listaConceptoNovedades.map((tipo) => {
                return { label: tipo.detalleConcepto, value: tipo.idConcepto.toString() };
            })
            this.setState({ listaTipoConcepto: listaAccion });
        })
    }

    handleChange = async (e) => {
        const { name, value } = e.target;
        if (name === "importe" && !validateNumber(value)) return;
        this.setState({ [name]: value });
    }

    handleChangeSelect = (option, config) => {
        this.setState({ [config.name]: option });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        const {
            fecha,
            importe,
            comboSeller,
            comboConceptos,
            ordenReferencia,
            observaciones
        } = this.state;

        if (!fecha) {
            toast.warn("Debe agregar una fecha");
            return;
        }

        if (!comboSeller.value) {
            toast.warn("Debe seleccionar un seller");
            return;
        }

        if (!comboConceptos.value) {
            toast.warn("Debe seleccionar un concepto");
            return;
        }

        if (!importe) {
            toast.warn("Debe agregar un importe");
            return;
        }

        let request = {
            fecha: fecha,
            idSeller: parseInt(comboSeller.value),
            concepto: parseInt(comboConceptos.value),
            importe: parseFloat(importe),
            ordenDeReferencia: ordenReferencia ? parseInt(ordenReferencia) : 0,
            observaciones: observaciones,
        }

        let post = postNovedad(request);

        post.then(res => {
            toast.success("La novedad fue creada con éxito.");
            this.clearInputs();
            return;
        }).catch(err => {
            toast.error("No pudimos crear la liquidación");
        });
    }

    mapSellers = () => {
        getLiquidacionesListaSellers().then(res => {
            let array = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            })
            this.setState({ listSellers: array });
        })
    }

    mapConceptos = () => {
        getTiposConceptos().then(res => {
            let listaAccion = res.listaConceptoNovedades.map((tipo) => {
                return { label: tipo.detalleConcepto, value: tipo.idConcepto.toString() };
            })
            this.setState({ listaTipoConcepto: listaAccion });
        })
    }

    clearInputs = () => {
        this.setState({
            comboSeller: { label: "", value: "" },
            comboConceptos: { label: "", value: "" },
            importe: "",
            ordenReferencia: "",
            observaciones: "",
        });
    }

    goToNovedades = () => {
        this.props.history.push("/Novedades");
    }


    render() {
        let listaSeller = [];
        if (this.props.listSellers != undefined) {
            this.props.listSellers.map((tipo) => {
                listaSeller.push({ label: tipo.razonSocial, value: tipo.codigo.toString() });
            });
        }

        let listaConcepto = [];
        if (this.props.tiposConceptos != undefined) {
            this.props.tiposConceptos.map((tipo) => {
                listaConcepto.push({ label: tipo.detalleConcepto, value: tipo.idConcepto });
            });
        }

        return (
            <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                <div className="ibox-content">
                    <div className="card">
                        <div className="row card-body justify-content-evenly align-items-center">

                            <div className="card-title mb-3 col-12">
                                <div className="row">
                                    <div className="col-12 col-sm-auto"><GoBackArrow /></div>
                                    <div className="col-12 col-sm-auto"><h4>Crear Novedad</h4></div>
                                </div>
                            </div>

                            <div className="row justify-content-evenly align-items-center">

                                <div className="col-12 col-md-2">
                                    <p className="font-bold">Fecha</p>
                                    <input
                                        type="date"
                                        name="fecha"
                                        className="form-control"
                                        min={this.state.fechaDesdeSesenta}
                                        defaultValue={this.state.fecha}
                                        onChange={this.handleChange}
                                    />
                                </div>

                                <div className="col-12 col-md-2">
                                    <p className="font-bold">Seller</p>
                                    <Select
                                        name="comboSeller"
                                        value={this.state.comboSeller}
                                        options={this.state.listSellers}
                                        onChange={this.handleChangeSelect}
                                        onMenuOpen={this.mapSellers}
                                        styles={EstiloCombos}
                                        components={{ DropdownIndicator: () => DropDownArrow }}
                                    />
                                </div>

                                <div className="col-12 col-md-2">
                                    <p className="font-bold">Concepto</p>
                                    <Select
                                        name="comboConceptos"
                                        value={this.state.comboConceptos}
                                        options={this.state.listaTipoConcepto}
                                        onChange={this.handleChangeSelect}
                                        onMenuOpen={this.mapConceptos}
                                        styles={EstiloCombos}
                                    />
                                </div>

                                <div className="col-12 col-md-2">
                                    <p className="font-bold">Importe</p>
                                    <input
                                        type="text"
                                        name="importe"
                                        className="form-control"
                                        onChange={this.handleChange}
                                        value={this.state.importe}
                                        maxLength="10"
                                        />
                                </div>

                                <div className="col-12 col-md-3">
                                    <p className="font-bold">Orden de Referencia</p>
                                    <input
                                        type="text"
                                        name="ordenReferencia"
                                        className="form-control"
                                        onChange={this.handleChange}
                                        maxLength="10"
                                        value={this.state.ordenReferencia}
                                    />
                                </div>

                                <div className="col-12 col-md-10 my-3">
                                    <p className="font-bold">Observaciones</p>
                                    <textarea
                                        rows="4"
                                        cols="100"
                                        name="observaciones"
                                        className="w-100"
                                        onChange={this.handleChange}
                                        value={this.state.observaciones}
                                    />
                                </div>
                            </div>

                            <div className="col-12 col-sm-auto">
                                <button
                                    type="submit"
                                    className="btn btn-sm background-rojo-megatone col-auto mx-2"
                                >
                                    Crear Novedad
                                </button>

                                <button
                                    type="button"
                                    onClick={this.goToNovedades}
                                    className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                                >
                                    Cancelar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    publicacion: state.publicaciones.publicacion,
    tiposConceptos: state.tipos.tipoLiquidacionConcepto,
    listSellers: state.sellers.lista_sellers_liquidaciones
});

export default connect(mapStateToProps, {
    fetchListaConceptos,
    fetchLiquidacionesListaSellers
})(NovedadNew);